module.exports = __webpack_public_path__ + "static/img/logo08.40a5efa.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/home/logo/logo08.jpg
// module id = nsp1
// module chunks = 1